__turbopack_context__.v({
  "counts": "milestones-module__nTr2mG__counts",
  "dash": "milestones-module__nTr2mG__dash",
  "image": "milestones-module__nTr2mG__image",
  "milestones": "milestones-module__nTr2mG__milestones",
  "ruler": "milestones-module__nTr2mG__ruler",
  "selected": "milestones-module__nTr2mG__selected",
});
